import { useState, useRef } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import service from "../../services/service";
import endpoints from "../../services/endpoints";
import "./Login.css";
import { BackArw } from "../../assests/ExportImageIcon";

const OTP = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const email = state?.email || "";
  const [otp, setOtp] = useState(["", "", "", ""]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const inputRefs = [useRef(), useRef(), useRef(), useRef()];

  const handleOtpChange = (index, value) => {
    if (!/^\d*$/.test(value)) return;
    const updated = [...otp];
    updated[index] = value.slice(-1);
    setOtp(updated);
    setError("");
    if (value && index < 3) inputRefs[index + 1].current.focus();
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs[index - 1].current.focus();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const otpValue = otp.join("");
    if (otpValue.length < 4) { setError("Please enter the 4-digit OTP"); return; }
    setLoading(true);
    setError("");
    try {
      await service.post(endpoints.auth.verifyotp, { email, otp: otpValue });
      navigate("/set-password", { state: { email } });
    } catch (err) {
      setError(err.response?.data?.message || "Invalid OTP. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="backArw" onClick={() => navigate("/forgot-password")}>
          <img src={BackArw} />
        </div>
        <div className="login-title">Enter OTP to verify your email</div>
        <p className="smallText mb-4">We've sent you an OTP to <span>{email}</span> <Link to="/forgot-password">EDIT</Link></p>
        <form onSubmit={handleSubmit} className="login-form">
          <div className="otpEnter">
            {otp.map((digit, i) => (
              <input
                key={i}
                type="text"
                inputMode="numeric"
                maxLength={1}
                value={digit}
                ref={inputRefs[i]}
                onChange={(e) => handleOtpChange(i, e.target.value)}
                onKeyDown={(e) => handleKeyDown(i, e)}
              />
            ))}
          </div>

          {error && <p className="login-error">{error}</p>}

          <button type="submit" className="commonOrngBtn" disabled={loading}>
            {loading ? "Verifying..." : "Verify"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default OTP;
